// Global alert event utilities
// Provides a typed helper for dispatching the `iehub-alert` CustomEvent consumed by AlertProvider.

export type GlobalAlertSeverity = "success" | "info" | "warning" | "error";
export type GlobalAlertVariant = "standard" | "filled" | "outlined";

export interface GlobalAlertOptions {
  readonly message: string;
  readonly severity?: GlobalAlertSeverity;
  readonly title?: string;
  readonly variant?: GlobalAlertVariant;
  readonly autoHide?: boolean;
  readonly duration?: number;
}

export interface GlobalAlertDetail extends GlobalAlertOptions {
  readonly severity: GlobalAlertSeverity;
}

const ALERT_EVENT_NAME = "iehub-alert";

export const emitGlobalAlert = (options: GlobalAlertOptions): void => {
  if (typeof window === "undefined") {
    return;
  }

  const detail: GlobalAlertDetail = {
    severity: options.severity ?? "info",
    message: options.message,
    ...(options.title ? { title: options.title } : {}),
    ...(options.variant ? { variant: options.variant } : {}),
    ...(options.autoHide !== undefined ? { autoHide: options.autoHide } : {}),
    ...(options.duration !== undefined ? { duration: options.duration } : {}),
  };

  try {
    window.dispatchEvent(
      new CustomEvent<GlobalAlertDetail>(ALERT_EVENT_NAME, { detail }),
    );
  } catch (error) {
    console.warn("Failed to emit global alert", error);
  }
};


